import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { ApplicantDetailsPersonsProps } from '@gov-nx/ui/types';
import { toDateReadable } from '@gov-nx/utils/common';

export const ApplicantDetailsBirthDate = ({
	individualPerson,
}: ApplicantDetailsPersonsProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Component);

	const birthDate = individualPerson?.datumNarozeni
		? toDateReadable(individualPerson.datumNarozeni)
		: null;

	if (!birthDate) {
		return null;
	}

	return (
		<div>
			<dt className="text-body-s">{t('zadatel.pole.udaje.datum-narozeni')}</dt>
			<dd className="text-(--text-secondary)">{birthDate}</dd>
		</div>
	);
};
